import { createFileRoute } from '@tanstack/react-router'
import SecuritySettings from '@/pages/settings/security'

export const Route = createFileRoute(
  '/(protected)/settings/security'
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <SecuritySettings />
}
